import React, { Component } from "react";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/fonts/font-awesome.min.css";
import "../../assets/css/styles.css";
import axios from "axios";
import $ from "jquery";
import logo from "../../assets/Images/HargeisaLogo.png";
import GynecologySidebar from "./GynecologySidebar";

export class Headers extends Component {
  constructor(props) {
    super(props);

//    const {api_url} = "http://127.0.0.1:8000/";
    const {api_url} = "https://hghobs.keshonect.co.ke/"

    // const url = 'hghobs.keshonect.co.ke'

    this.state = {
      module: "",
      profession: "",
      name: "",
      nationality: "",
      age: "",
      currentSpecialty: localStorage.getItem('currentSpecialty'),
      logoutLoading: false
    };

    this.url = "";
    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout = (event) => {
    // const url = ''
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    event.preventDefault();
    this.setState({
      logoutLoading: true
    })
    axios
      .post(this.api_url+"staff/logout", this.state, {
        headers: headers,
      })
      .then((response) => {
        this.setState({
          logoutLoading: false
        })
        if (response.data["success"] == "logged out") {
          $("#logoutSuccess").show();
          localStorage.removeItem("accessToken");
          localStorage.clear();
          // setTimeout(function (props) {
          // history.push('/reception/dashboard')
          setTimeout(function () {
            window.location.href = "/";
          }, 1000);

          // }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  componentDidMount() {
    // $('#').show()

    $(".logoImg").click(function (e) {
      e.preventDefault();
      
      localStorage.removeItem("currentVisitId");
      localStorage.removeItem("currentVisitName");
      localStorage.removeItem("currentVisitNationality");
      localStorage.removeItem("currentVisitProfession");
      localStorage.removeItem("currentVisitAge");
      localStorage.removeItem("currentModule");
     
      // setTimeout(function () {
        if (
          localStorage.getItem('currentSpecialty') == "doctor" ||
          localStorage.getItem('currentSpecialty') == "nurse"
        ) {
          window.location.href = "/medical/home";
  
        
        } else if (localStorage.getItem('currentSpecialty') == "receptionist") {
          window.location.href = "/reception/dashboard";
        } else if (localStorage.getItem('currentSpecialty') == "Chief of Obstetrics") {
          window.location.href = "/admin/dashboard";
        } else if (localStorage.getItem('currentSpecialty') == "labtech") {
         
          // window.location.href = "/lab/search/in/module";
        }

      // }, 500);
      // href='/'
    });
    $(".checkHistory").click(function () {
      $(".HistoryModal").show();
    });
    console.log(localStorage.getItem("accessToken"));
    console.log(localStorage.getItem("currentVisitId"));
    console.log(localStorage.getItem("currentVisitName"));
    console.log(localStorage.getItem("currentVisitNationality"));
    console.log(localStorage.getItem("currentVisitProfession"));
    console.log(localStorage.getItem("currentVisitAge"));
    this.setState({
      age: localStorage.getItem("currentVisitAge"),
      name: localStorage.getItem("currentVisitName"),
      nationality: localStorage.getItem("currentVisitNationality"),
      profession: localStorage.getItem("currentVisitProfession"),
    });

    if (localStorage.getItem("currentVisitName")) {
      $(".patientDetails").show();
    }
    $(".close").on("click", function () {
      $(".modal").hide();
    });

    if (localStorage.getItem("accessToken") == null) {
      $(".loginFirst").show();
      setTimeout(function () {
        window.location.href = "/";
      }, 1000);
    }

    $(".visitid").text(localStorage.getItem("currentVisitId"));

    var visitid = localStorage.getItem("currentVisitId");

    localStorage.setItem("visitId", visitid);
  }

  handleTableChange(event) {
    console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    var self = this;
    this.setState({ AnteNatalHistoryTableResult: event });
    setTimeout(function () {
      console.log(self.state);
    }, 500);
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const logoDimensions = { height: "50px", innerWidth: "180px" };

    const data = [
      ["1st", "", ""],
      ["2nd", "", ""],
      ["3rd", "", ""],
      // ["4th", "", ""],
    ];
    const columns = ["Trimester", "Date", "Result"];

    const { profession, name, nationality, age, logoutLoading } = this.state;
    return (
      <div>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <header>
          <nav className="navbar  navbari-light navbar-expand-md background-blue navbar-fixed-top">
            <div className="container-fluid">
             
              <a className="navbar-brand logoImg">
                <img src={logo} style={logoDimensions} />
              </a>
              <button
                data-toggle="collapse"
                className="navbar-toggler"
                data-target="#navcol-1"
              >
                {/* <span className="sr-only">Toggle navigation</span> */}
                <span className="navbar-toggler-icon"></span>
                
              </button>
              
              <div
                className="collapse navbar-collapse justify-content-center"
                id="navcol-1"
              >
                <ul className="navbar-nav justify-content-center">
                  <li className="nav-item"><p style={{color:"white"}}>Current User Logged In: {localStorage.getItem("Currentusername")}</p></li><br/>
                  {localStorage.getItem("currentModule") ?<p style={{color:"white"}}>||   Current Module: { localStorage.getItem("currentModule")}</p>: <p></p>}

                  {/* <li ><a className="nav-link active font-weight-bold text-capitalize" >Staff Registration</a></li> */}
                </ul>
              </div>
             
              
              <button className="btn btn-primary logout_btn" onClick={this.handleLogout}>
               {logoutLoading ? 'Loading' : 'Logout'} 
              </button>
            </div>
          </nav>

          {/* <div  className="alert alert-success" style={displayHidden} role="alert">
                        <strong>Success! </strong>Logout
                        Successful.
                    </div> */}

          {/* <div  className="modal loginFirst" style={displayHidden} role="alert">
                        
                    </div> */}
        </header>

        <div className="modal loginFirst" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title PatientName"></h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <strong>Success! </strong>Please Login First to Access this Page
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
        <div className="modal" id="logoutSuccess" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title PatientName"></h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <strong>Success! </strong>Logout Successful.
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
        {/* <GynecologySidebar/> */}
      </div>
    );
  }
}

export default Headers;
